<template>
<div class="help-center">
    <!-- HERO -->
    <section class="help-hero">
        <div class="help-hero-icon">
            <i class="fad fa-question-circle"></i>
        </div>
        <div class="help-hero-main">
            <div class="help-hero-top">
                <div class="help-hero-titles">
                    <h2 class="help-title">{{ help.TITOLO }}</h2>
                    <div class="help-subtitle">{{ help.SOTTOTITOLO }}</div>
                </div>
                <button v-if="$root.utente.FK_ID_LIVELLO == 1" type="button" class="help-edit-button" @click="modificaHelp(21)">
                    <i class="fad fa-edit"></i>
                    <span>Modifica</span>
                </button>
            </div>
            <div class="help-meta">
                <div class="help-meta-item help-meta-status">
                    <span class="help-status-dot"></span>
                    <span>Guida aggiornata</span>
                </div>
                <div class="help-meta-item">
                    <i class="fad fa-clock help-icon-blue"></i>
                    <span>{{ readingTime }} min lettura</span>
                </div>
                <div v-if="help.DATE_ADD" class="help-meta-item help-meta-date">
                    <i class="fad fa-calendar-alt help-icon-purple"></i>
                    <span>{{ filters.formatDate(help.DATE_ADD) }}</span>
                </div>
            </div>
        </div>
    </section>

    <!-- NAV -->
    <nav class="help-nav-wrapper">
        <div class="help-nav">
            <button v-for="tab in tabs" :key="tab.id" type="button" class="help-nav-item" :class="{ active: activeTab === tab.id }" @click="setTab(tab.id)">
                <i :class="[tab.icon, 'help-nav-fa-icon']"></i>
                <span>{{ tab.label }}</span>
                <span v-if="tab.id === 'video' && help.CUSTOM_2" class="help-nav-dot"></span>
            </button>
        </div>
    </nav>

    <!-- CONTENT -->
    <main ref="helpContent" class="help-content">
        <!-- PANORAMICA -->
        <div v-if="activeTab === 'overview'" class="help-tab-content">
            <section class="help-card help-intro-card">
                <div class="help-section-title">
                    <div class="help-section-icon help-icon-orange">
                        <i class="fad fa-home"></i>
                    </div>
                    <div class="help-section-title-text">
                        <h3>Benvenuto</h3>
                        <p v-if="help.SOTTOTITOLO">{{ help.SOTTOTITOLO }}</p>
                    </div>
                </div>
                <div v-if="help.TESTO_HOME" class="help-html-content" v-html="help.TESTO_HOME"></div>
                <div v-else class="help-intro-empty">
                    <div class="help-intro-empty-icon">
                        <i class="fad fa-info-circle help-icon-blue"></i>
                    </div>
                    <div>
                        <strong>Introduzione non ancora disponibile</strong>
                        <span>Questa guida è stata predisposta ma il contenuto introduttivo non è ancora stato inserito.</span>
                    </div>
                </div>
                <div v-if="introExcerpt" class="help-summary-box">
                    <div class="help-summary-icon">
                        <i class="fad fa-lightbulb help-icon-orange"></i>
                    </div>
                    <div class="help-summary-content">
                        <strong>In breve</strong>
                        <p>{{ introExcerpt }}</p>
                    </div>
                </div>
            </section>

            <section class="help-card">
                <div class="help-card-heading">
                    <div>
                        <span class="help-eyebrow">APPROFONDISCI</span>
                        <h3>Esplora la guida</h3>
                    </div>
                </div>
                <div class="help-explore-grid" :class="{ 'help-explore-grid-three': !help.CUSTOM_2, 'help-explore-grid-four': help.CUSTOM_2 }">
                    <button type="button" class="help-explore-card" @click="setTab('usage')">
                        <div class="help-explore-icon help-bg-blue">
                            <i class="fad fa-graduation-cap"></i>
                        </div>
                        <div class="help-explore-text">
                            <strong>Come si usa</strong>
                            <span>Procedure e istruzioni</span>
                        </div>
                        <i class="fad fa-arrow-up-right help-explore-arrow"></i>
                    </button>
                    <button type="button" class="help-explore-card" @click="setTab('features')">
                        <div class="help-explore-icon help-bg-pink">
                            <i class="fad fa-th-large"></i>
                        </div>
                        <div class="help-explore-text">
                            <strong>Funzioni</strong>
                            <span>Tutti gli strumenti</span>
                        </div>
                        <i class="fad fa-arrow-up-right help-explore-arrow"></i>
                    </button>
                    <button type="button" class="help-explore-card" @click="setTab('faq')">
                        <div class="help-explore-icon help-bg-purple">
                            <i class="fad fa-question-circle"></i>
                        </div>
                        <div class="help-explore-text">
                            <strong>FAQ</strong>
                            <span>Domande frequenti</span>
                        </div>
                        <i class="fad fa-arrow-up-right help-explore-arrow"></i>
                    </button>
                    <button v-if="help.CUSTOM_2" type="button" class="help-explore-card" @click="setTab('video')">
                        <div class="help-explore-icon help-bg-green">
                            <i class="fad fa-play-circle"></i>
                        </div>
                        <div class="help-explore-text">
                            <strong>Video</strong>
                            <span>Tutorial della pagina</span>
                        </div>
                        <i class="fad fa-arrow-up-right help-explore-arrow"></i>
                    </button>
                </div>
            </section>

            <section v-if="help.TESTO_NOTE" class="help-card help-note-preview">
                <div class="help-note-preview-icon">
                    <i class="fad fa-sticky-note"></i>
                </div>
                <div class="help-note-preview-content">
                    <span>NOTE</span>
                    <strong>Sono disponibili informazioni aggiuntive</strong>
                </div>
                <button type="button" class="help-note-preview-button" @click="setTab('notes')">
                    Leggi
                    <i class="fad fa-arrow-right"></i>
                </button>
            </section>
        </div>

        <!-- COME SI USA -->
        <div v-if="activeTab === 'usage'" class="help-tab-content">
            <section class="help-card help-main-card">
                <div class="help-page-heading">
                    <div class="help-page-icon help-bg-blue">
                        <i class="fad fa-graduation-cap"></i>
                    </div>
                    <div>
                        <span class="help-eyebrow">GUIDA OPERATIVA</span>
                        <h2>Come si usa</h2>
                        <p>Istruzioni e procedure dedicate a questa pagina.</p>
                    </div>
                </div>
                <div v-if="help.TESTO_BODY" class="help-html-content help-html-large" v-html="helpBodyHtml" @click="handleHelpBodyClick"></div>
                <div v-else class="help-empty">
                    <div class="help-empty-icon help-bg-blue">
                        <i class="fad fa-book-open"></i>
                    </div>
                    <strong>Guida non ancora disponibile</strong>
                    <span>Non sono ancora state inserite istruzioni operative.</span>
                </div>
            </section>
        </div>

        <!-- FUNZIONI -->
        <div v-if="activeTab === 'features'" class="help-tab-content">
            <section class="help-card help-main-card">
                <div class="help-page-heading">
                    <div class="help-page-icon help-bg-pink">
                        <i class="fad fa-magic"></i>
                    </div>
                    <div>
                        <span class="help-eyebrow">FUNZIONALITÀ</span>
                        <h2>Funzioni</h2>
                        <p>Approfondimenti sulle funzionalità disponibili.</p>
                    </div>
                </div>
                <div v-if="help.TESTO_INFO" class="help-html-content help-html-large" v-html="help.TESTO_INFO"></div>
                <div v-else class="help-empty">
                    <div class="help-empty-icon help-bg-pink">
                        <i class="fad fa-tools"></i>
                    </div>
                    <strong>Nessuna funzione documentata</strong>
                    <span>Non sono ancora presenti approfondimenti per questa pagina.</span>
                </div>
            </section>
        </div>

        <!-- FAQ -->
        <div v-if="activeTab === 'faq'" class="help-tab-content">
            <section class="help-card help-main-card">
                <div class="help-page-heading">
                    <div class="help-page-icon help-bg-purple">
                        <i class="fad fa-question-circle"></i>
                    </div>
                    <div>
                        <span class="help-eyebrow">SUPPORTO</span>
                        <h2>Domande frequenti</h2>
                        <p>Risposte rapide alle domande più comuni.</p>
                    </div>
                </div>
                <div class="help-faq-placeholder">
                    <div class="help-faq-placeholder-top">
                        <div class="help-faq-placeholder-icon">
                            <i class="fad fa-database"></i>
                        </div>
                        <div>
                            <strong>FAQ dinamiche</strong>
                            <span>Questa sezione verrà alimentata direttamente dal database.</span>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <!-- VIDEO -->
        <div v-if="activeTab === 'video'" class="help-tab-content">
            <section class="help-card help-main-card">
                <div class="help-page-heading">
                    <div class="help-page-icon help-bg-green">
                        <i class="fad fa-play-circle"></i>
                    </div>
                    <div>
                        <span class="help-eyebrow">VIDEO TUTORIAL</span>
                        <h2>Guarda la guida</h2>
                        <p>Tutorial video dedicato a questa pagina.</p>
                    </div>
                </div>
                <div v-if="help.CUSTOM_2" class="help-video">
                    <iframe :src="filters.toEmbedVideoUrl(help.CUSTOM_2)" frameborder="0" allowfullscreen></iframe>
                </div>
                <div v-else class="help-empty">
                    <div class="help-empty-icon help-bg-green">
                        <i class="fad fa-video-slash"></i>
                    </div>
                    <strong>Nessun video disponibile</strong>
                    <span>Non è ancora stato inserito un tutorial per questa pagina.</span>
                </div>
            </section>
        </div>

        <!-- NOTE -->
        <div v-if="activeTab === 'notes'" class="help-tab-content">
            <section class="help-card help-main-card">
                <div class="help-page-heading">
                    <div class="help-page-icon help-bg-orange">
                        <i class="fad fa-sticky-note"></i>
                    </div>
                    <div>
                        <span class="help-eyebrow">INFORMAZIONI</span>
                        <h2>Note</h2>
                        <p>Avvisi e informazioni aggiuntive.</p>
                    </div>
                </div>
                <div v-if="help.TESTO_NOTE" class="help-html-content help-html-large" v-html="help.TESTO_NOTE"></div>
                <div v-else class="help-empty">
                    <div class="help-empty-icon help-bg-orange">
                        <i class="fad fa-file-alt"></i>
                    </div>
                    <strong>Nessuna nota</strong>
                    <span>Non sono presenti informazioni aggiuntive.</span>
                </div>
            </section>
        </div>
    </main>
</div>
</template>

<script>
export default {
    name: "SchedaVisualizzazioneHelp",
    props: ["modulo"],
    data: function() {
        return {
            filters: global.filters,
            help: {},
            activeTab: "overview",
            targetTimer: null,
            tabs: [
                { id: "overview", label: "Panoramica", icon: "fad fa-home" },
                { id: "usage", label: "Come si usa", icon: "fad fa-graduation-cap" },
                { id: "features", label: "Funzioni", icon: "fad fa-th-large" },
                { id: "faq", label: "FAQ", icon: "fad fa-question-circle" },
                { id: "video", label: "Video", icon: "fad fa-play-circle" },
                { id: "notes", label: "Note", icon: "fad fa-sticky-note" }
            ]
        };
    },

    computed: {
        readingTime: function() {
            var content = [
                this.help.TESTO_HOME,
                this.help.TESTO_BODY,
                this.help.TESTO_INFO,
                this.help.TESTO_NOTE
            ].filter(Boolean).join(" ").replace(/<[^>]+>/g, " ").replace(/\[HELP:[a-zA-Z0-9_-]+\]/g, " ");
            var words = content.trim().split(/\s+/).filter(Boolean).length;
            return Math.max(1, Math.ceil(words / 200));
        },

        introExcerpt: function() {
            if (!this.help.TESTO_HOME) {
                return "";
            }
            var text = this.help.TESTO_HOME
                .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "")
                .replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, "")
                .replace(/<[^>]+>/g, " ")
                .replace(/&nbsp;/g, " ")
                .replace(/&amp;/g, "&")
                .replace(/&quot;/g, '"')
                .replace(/&#039;/g, "'")
                .replace(/\s+/g, " ")
                .trim();
            if (!text) {
                return "";
            }
            return text.length <= 170 ? text : text.substring(0, 170).trim() + "...";
        },

        helpTargets: function() {
            if (!this.help.TESTO_ADMIN) {
                return [];
            }
            try {
                var raw = String(this.help.TESTO_ADMIN).trim();
                raw = raw
                    .replace(/^<p>/i, '')
                    .replace(/<\/p>$/i, '')
                    .replace(/<br\s*\/?>/gi, '')
                    .trim();

                var data = JSON.parse(raw);

                if (!Array.isArray(data)) {
                    return [];
                }

                return data
                    .filter(function(item) {
                        return item && item.id && item.target;
                    })
                    .map(function(item) {
                        return Object.assign({}, item, {
                            exists: !!document.querySelector(
                                '[data-help="' + item.target + '"]'
                            )
                        });
                    });

            } catch (error) {
                console.warn(
                    'TESTO_ADMIN contiene JSON non valido:',
                    error
                );
                return [];
            }
        },

        helpTargetsById: function() {
            var map = {};
            this.helpTargets.forEach(function(item) {
                map[item.id] = item;
            });
            return map;
        },

        helpBodyHtml: function() {
            var html = this.help.TESTO_BODY || "";
            if (!html) {
                return "";
            }
            var targets = this.helpTargetsById;
            var escapeHtml = function(value) {
                return String(value == null ? "" : value)
                    .replace(/&/g, "&amp;")
                    .replace(/</g, "&lt;")
                    .replace(/>/g, "&gt;")
                    .replace(/"/g, "&quot;")
                    .replace(/'/g, "&#039;");
            };
            var cleanIcon = function(value) {
                var icon = String(value || "fad fa-crosshairs");
                return /^[a-zA-Z0-9 _-]+$/.test(icon) ? icon : "fad fa-crosshairs";
            };
            return html.replace(/\[HELP:([a-zA-Z0-9_-]+)\]/g, function(match, id) {
                var item = targets[id];
                if (!item) {
                    return '<span class="help-inline-target-missing"><i class="fad fa-exclamation-triangle"></i> Target "' + escapeHtml(id) + '" non configurato</span>';
                }
                if (!item.exists) {
                    return '<span class="help-inline-target-missing"><i class="fad fa-exclamation-triangle"></i> ' + escapeHtml(item.label || "Elemento") + ' non disponibile</span>';
                }
                var label = escapeHtml(item.label || "Mostrami");
                var icon = cleanIcon(item.icon);
                return '<button type="button" class="help-inline-target-button" data-help-action="' + escapeHtml(id) + '"><span class="help-inline-target-icon"><i class="' + icon + '"></i></span><span class="help-inline-target-label">' + label + '</span><i class="fad fa-crosshairs help-inline-target-crosshair"></i></button>';
            });
        }
    },

    beforeUnmount: function() {
        if (this.targetTimer) {
            clearTimeout(this.targetTimer);
        }
        document.querySelectorAll(".help-target-active").forEach(function(item) {
            item.classList.remove("help-target-active");
        });
    },

    methods: {
        openSchedaVisualizzazioneHelp: function(_modulo) {
            this.help = {};
            this.activeTab = "overview";
            var moduloTipologica = this.$root.getLangModulo(_modulo);
            utils.get("shared/contenuti/help", {
                ID_MODULO: _modulo,
                FK_ID_MODULO_TIPOLOGICA: moduloTipologica ? moduloTipologica.ID_OPZIONE_TIPOLOGICA : null
            }, (response) => {
                if (response.esito == 0) {
                    this.help = response.data;
                }
            });
        },
        setTab: function(tab) {
            this.activeTab = tab;
            this.$nextTick(() => {
                if (this.$refs.helpContent) {
                    this.$refs.helpContent.scrollTop = 0;
                }
            });
        },
        handleHelpBodyClick: function(event) {
            var button = event.target.closest("[data-help-action]");
            if (!button || !event.currentTarget.contains(button)) {
                return;
            }
            var id = button.getAttribute("data-help-action");
            var item = this.helpTargetsById[id];
            if (item && item.exists) {
                this.showHelpTarget(item.target);
            }
        },
        showHelpTarget: function(target) {
            var element = document.querySelector('[data-help="' + target + '"]');
            if (!element) {
                console.warn("Help target non trovato:", target);
                return;
            }
            document.querySelectorAll(".help-target-active").forEach(function(item) {
                item.classList.remove("help-target-active");
            });
            if (this.targetTimer) {
                clearTimeout(this.targetTimer);
            }
            void element.offsetWidth;
            element.classList.add("help-target-active");
            this.targetTimer = setTimeout(function() {
                element.classList.remove("help-target-active");
            }, 6000);
        }
    }
};
</script>

<style scoped>
.help-center{--help-primary:#3977f6;--help-primary-soft:#edf4ff;--help-pink:#e45179;--help-pink-soft:#fff1f5;--help-green:#24b879;--help-green-soft:#ebfaf3;--help-purple:#7658dc;--help-purple-soft:#f2efff;--help-orange:#efa346;--help-orange-soft:#fff6e9;--help-text:#26334b;--help-muted:#778297;--help-border:#e2e7ef;--help-bg:#f7f9fd;height:100%;min-height:0;display:flex;flex-direction:column;overflow:hidden;background:var(--help-bg);color:var(--help-text);font-size:14px;}
.help-hero{flex:0 0 auto;display:flex;align-items:center;gap:15px;padding:18px 30px 16px;background:#fff;border-bottom:1px solid var(--help-border);}
.help-hero-icon{width:60px;height:60px;min-width:60px;display:flex;align-items:center;justify-content:center;border-radius:50%;background:linear-gradient(135deg,#ea3f6f,#df5a7b);color:#fff;font-size:25px;box-shadow:0 8px 22px rgba(226,74,116,.16);}
.help-hero-main{width:100%;min-width:0;}
.help-hero-top{display:flex;align-items:flex-start;justify-content:space-between;gap:14px;}
.help-hero-titles{min-width:0;}
.help-title{margin:0 0 2px;color:var(--help-text);font-size:22px;font-weight:700;line-height:1.15;}
.help-subtitle{max-width:390px;color:var(--help-muted);font-size:12px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.help-edit-button{display:flex;align-items:center;gap:6px;padding:6px 9px;border:1px solid #f3bdca;border-radius:8px;background:#fff8fa;color:var(--help-pink);font-size:11px;font-weight:600;transition:.2s ease;}
.help-edit-button:hover{background:var(--help-pink-soft);border-color:#ed9db1;transform:translateY(-1px);}
.help-meta{display:flex;align-items:center;flex-wrap:wrap;gap:11px;margin-top:8px;}
.help-meta-item{display:flex;align-items:center;gap:4px;color:#7b8798;font-size:10px;white-space:nowrap;}
.help-meta-item i{font-size:13px;}
.help-meta-status{color:#69768a;}
.help-status-dot{width:6px;height:6px;border-radius:50%;background:#3abe83;box-shadow:0 0 0 4px rgba(58,190,131,.10);}
.help-nav-wrapper{position:relative;top:auto;flex:0 0 auto;z-index:15;padding:0 18px;background:#fff;border-top:1px solid #f0f2f6;border-bottom:1px solid var(--help-border);box-shadow:0 1px 4px rgba(31,47,70,.025);}
.help-nav{display:flex;align-items:stretch;justify-content:space-between;overflow-x:auto;scrollbar-width:none;}
.help-nav::-webkit-scrollbar{display:none;}
.help-nav-item{position:relative;display:flex;align-items:center;justify-content:center;gap:5px;min-width:max-content;margin:5px 1px;padding:9px;border:0;border-radius:7px;background:transparent;color:#59667a;font-size:10px;white-space:nowrap;transition:.18s ease;}
.help-nav-item i{font-size:14px;}
.help-nav-item:hover{background:#fff7f9;color:var(--help-pink);}
.help-nav-item.active{background:#fff2f5;color:var(--help-pink);font-weight:600;}
.help-nav-item.active::after{content:"";position:absolute;left:9px;right:9px;bottom:-6px;height:2px;border-radius:4px 4px 0 0;background:var(--help-pink);}
.help-nav-dot{position:absolute;top:5px;right:3px;width:5px;height:5px;border-radius:50%;background:#2fbd80;}
.help-nav-fa-icon{--fa-secondary-opacity:.45;}
.help-content{flex:1 1 auto;min-height:0;overflow-x:hidden;overflow-y:auto;padding:16px 24px 24px;scrollbar-gutter:stable;}
.help-tab-content{animation:helpFadeIn .18s ease;}
.help-card{margin-bottom:14px;padding:18px;border:1px solid var(--help-border);border-radius:11px;background:#fff;box-shadow:0 2px 8px rgba(38,51,75,.025);}
.help-intro-card{padding-bottom:17px;}
.help-main-card{min-height:430px;}
.help-section-title{display:flex;align-items:flex-start;gap:9px;}
.help-section-title-text h3{margin:0;color:var(--help-text);font-size:16px;font-weight:700;}
.help-section-title-text p{margin:3px 0 0;color:var(--help-muted);font-size:11px;}
.help-section-icon{display:flex;align-items:center;justify-content:center;width:28px;height:28px;min-width:28px;font-size:21px;}
.help-html-content{margin-top:14px;color:#556176;font-size:12px;line-height:1.7;}
.help-html-large{margin-top:22px;font-size:12px;}
.help-intro-empty{display:flex;align-items:center;gap:10px;margin-top:14px;padding:11px 12px;border-radius:8px;background:#f7f9fc;color:#8994a5;}
.help-intro-empty-icon{display:flex;align-items:center;justify-content:center;width:31px;height:31px;min-width:31px;border-radius:8px;background:#edf2f8;color:#8190a6;font-size:15px;}
.help-intro-empty strong{display:block;color:#687589;font-size:10px;font-weight:600;}
.help-intro-empty span{display:block;margin-top:2px;color:#98a2b1;font-size:9px;line-height:1.45;}
.help-summary-box{display:flex;align-items:flex-start;gap:11px;margin-top:14px;padding:12px 14px;border:1px solid #f4ccd6;border-radius:8px;background:linear-gradient(100deg,#fff7f9,#fffbfc);}
.help-summary-icon{width:25px;min-width:25px;padding-top:1px;color:#f2a13d;font-size:18px;}
.help-summary-content strong{display:block;margin-bottom:3px;color:var(--help-pink);font-size:11px;}
.help-summary-content p{margin:0;color:#657186;font-size:10px;line-height:1.55;}
.help-card-heading{display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:13px;}
.help-card-heading h3{margin:2px 0 0;color:var(--help-text);font-size:15px;font-weight:700;}
.help-eyebrow{display:block;color:#98a2b3;font-size:8px;font-weight:700;letter-spacing:.75px;}
.help-explore-grid{display:grid;gap:8px;}
.help-explore-grid-three{grid-template-columns:repeat(3,minmax(0,1fr));}
.help-explore-grid-four{grid-template-columns:repeat(2,minmax(0,1fr));}
.help-explore-card{position:relative;display:flex;align-items:center;gap:8px;min-height:62px;padding:10px;border:1px solid #e4e8ef;border-radius:8px;background:#fff;text-align:left;transition:.18s ease;}
.help-explore-card:hover{border-color:#cbd8ee;box-shadow:0 5px 14px rgba(40,61,95,.05);transform:translateY(-1px);}
.help-explore-icon{display:flex;align-items:center;justify-content:center;width:34px;height:34px;min-width:34px;border-radius:8px;font-size:17px;}
.help-explore-text{min-width:0;padding-right:10px;}
.help-explore-text strong{display:block;color:#344058;font-size:10px;font-weight:600;}
.help-explore-text span{display:block;margin-top:2px;color:#8a94a5;font-size:8px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.help-explore-arrow{position:absolute;top:8px;right:8px;color:#a0aaba;font-size:11px;}
.help-note-preview{display:flex;align-items:center;gap:10px;padding:12px 14px;}
.help-note-preview-icon{display:flex;align-items:center;justify-content:center;width:35px;height:35px;min-width:35px;border-radius:8px;background:var(--help-orange-soft);color:var(--help-orange);font-size:17px;}
.help-note-preview-content{flex:1;min-width:0;}
.help-note-preview-content span{display:block;color:#a4aebb;font-size:7px;font-weight:700;letter-spacing:.7px;}
.help-note-preview-content strong{display:block;margin-top:2px;color:#556176;font-size:9px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.help-note-preview-button{display:flex;align-items:center;gap:4px;padding:6px 8px;border:0;background:transparent;color:#437bf1;font-size:9px;font-weight:600;}
.help-page-heading{display:flex;align-items:flex-start;gap:12px;padding-bottom:16px;border-bottom:1px solid #edf0f4;}
.help-page-icon{display:flex;align-items:center;justify-content:center;width:42px;height:42px;min-width:42px;border-radius:10px;font-size:20px;}
.help-page-heading h2{margin:2px 0 3px;color:var(--help-text);font-size:18px;font-weight:700;}
.help-page-heading p{margin:0;color:#7d8798;font-size:10px;}
.help-bg-blue{background:var(--help-primary-soft);color:var(--help-primary);--fa-primary-color:#3977f6;--fa-secondary-color:#8eb2ff;--fa-secondary-opacity:.65;}
.help-bg-pink{background:var(--help-pink-soft);color:var(--help-pink);--fa-primary-color:#e45179;--fa-secondary-color:#f5a7bc;--fa-secondary-opacity:.65;}
.help-bg-green{background:var(--help-green-soft);color:var(--help-green);--fa-primary-color:#24b879;--fa-secondary-color:#8be0ba;--fa-secondary-opacity:.65;}
.help-bg-purple{background:var(--help-purple-soft);color:var(--help-purple);--fa-primary-color:#7658dc;--fa-secondary-color:#b8a8f4;--fa-secondary-opacity:.65;}
.help-bg-orange{background:var(--help-orange-soft);color:var(--help-orange);--fa-primary-color:#efa346;--fa-secondary-color:#ffd18d;--fa-secondary-opacity:.70;}
.help-icon-blue{color:#3977f6;--fa-primary-color:#3977f6;--fa-secondary-color:#8eb2ff;--fa-secondary-opacity:.65;}
.help-icon-purple{color:#7658dc;--fa-primary-color:#7658dc;--fa-secondary-color:#b8a8f4;--fa-secondary-opacity:.65;}
.help-icon-orange{color:#efa346;--fa-primary-color:#efa346;--fa-secondary-color:#ffd18d;--fa-secondary-opacity:.75;}
.help-empty{min-height:300px;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;color:#8a95a6;}
.help-empty-icon{display:flex;align-items:center;justify-content:center;width:54px;height:54px;margin-bottom:12px;border-radius:14px;font-size:25px;}
.help-empty strong{display:block;margin-bottom:4px;color:#59667a;font-size:12px;}
.help-empty span{max-width:320px;color:#929cac;font-size:10px;line-height:1.5;}
.help-faq-placeholder{margin-top:18px;}
.help-faq-placeholder-top{display:flex;align-items:center;gap:10px;padding:12px;border:1px dashed #d9dfeb;border-radius:8px;background:#fbfcfe;}
.help-faq-placeholder-icon{display:flex;align-items:center;justify-content:center;width:34px;height:34px;min-width:34px;border-radius:8px;background:var(--help-purple-soft);color:var(--help-purple);font-size:16px;}
.help-faq-placeholder-top strong{display:block;color:#526075;font-size:10px;}
.help-faq-placeholder-top span{display:block;margin-top:2px;color:#909bad;font-size:8px;}
.help-video{position:relative;margin-top:18px;padding-top:56.25%;overflow:hidden;border-radius:9px;background:#121722;box-shadow:0 6px 18px rgba(22,30,44,.12);}
.help-video iframe{position:absolute;inset:0;width:100%;height:100%;border:0;}
.help-html-content :deep(h1){margin-top:18px;color:var(--help-text);font-weight:700;}
.help-html-content :deep(h2){margin-top:18px;color:var(--help-text);font-weight:700;}
.help-html-content :deep(h3){margin-top:16px;color:var(--help-text);font-weight:700;}
.help-html-content :deep(h4){margin-top:14px;color:var(--help-text);font-weight:700;}
.help-html-content :deep(p){margin-bottom:9px;}
.help-html-content :deep(ul){padding-left:20px;}
.help-html-content :deep(ol){padding-left:20px;}
.help-html-content :deep(li){margin-bottom:5px;}
.help-html-content :deep(a){color:var(--help-primary);font-weight:500;}
.help-html-content :deep(img){max-width:100%;height:auto;border-radius:9px;}
.help-html-content :deep(table){width:100%;margin:12px 0;border-collapse:collapse;}
.help-html-content :deep(th){padding:7px;border:1px solid #e1e6ee;background:#f5f7fb;}
.help-html-content :deep(td){padding:7px;border:1px solid #e1e6ee;}
.help-html-content :deep(blockquote){margin:14px 0;padding:11px 13px;border-left:3px solid var(--help-primary);border-radius:0 7px 7px 0;background:var(--help-primary-soft);}
.help-html-content :deep(hr){margin:17px 0;border:0;border-top:1px solid #e7ebf1;}
.help-html-content :deep(.help-inline-target-button){display:inline-flex;align-items:center;gap:8px;width:auto;min-width:0;margin:6px 0;padding:6px 10px;border:1px solid #e8a3b6;border-radius:7px;background:#fff7fa;color:#bd4b69;font-size:10px;font-weight:600;line-height:1;vertical-align:middle;box-shadow:0 2px 6px rgba(223,91,128,.05);transition:.18s ease;}
.help-html-content :deep(.help-inline-target-button:hover){background:#fff0f4;border-color:#df5b80;color:#b33d5f;box-shadow:0 4px 12px rgba(223,91,128,.12);transform:translateY(-1px);}
.help-html-content :deep(.help-inline-target-icon){display:inline-flex;align-items:center;justify-content:center;width:20px;height:20px;min-width:20px;border-radius:5px;background:#ffe9ef;color:#df5b80;font-size:10px;--fa-primary-color:#df5b80;--fa-secondary-color:#f2a3b8;--fa-secondary-opacity:.65;}
.help-html-content :deep(.help-inline-target-label){white-space:nowrap;}
.help-html-content :deep(.help-inline-target-crosshair){margin-left:3px;color:#df5b80;font-size:10px;--fa-primary-color:#df5b80;--fa-secondary-color:#f5b1c3;--fa-secondary-opacity:.65;}
.help-html-content :deep(.help-inline-target-missing){display:inline-flex;align-items:center;gap:5px;margin:4px 3px;padding:5px 8px;border:1px dashed #e3b4c0;border-radius:999px;background:#fff8fa;color:#b66b7f;font-size:9px;vertical-align:middle;}

@keyframes helpFadeIn{from{opacity:0;transform:translateY(3px);}to{opacity:1;transform:translateY(0);}}
@media(max-width:700px){
.help-hero{padding:16px 20px;}
.help-content{padding:14px 16px;}
.help-nav-wrapper{padding:0 8px;}
.help-nav-item{padding-left:7px;padding-right:7px;font-size:9px;}
}
@media(max-width:600px){
.help-explore-grid-three{grid-template-columns:1fr;}
.help-explore-grid-four{grid-template-columns:1fr 1fr;}
}
@media(max-width:520px){
.help-hero-icon{width:52px;height:52px;min-width:52px;font-size:22px;}
.help-title{font-size:19px;}
.help-meta-date{display:none;}
.help-edit-button span{display:none;}
.help-edit-button{width:31px;height:31px;justify-content:center;padding:0;}
.help-explore-grid-four{grid-template-columns:1fr;}
}
</style>
